import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=d23448b2&"
import script from "./DocumentsTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports